class ABCollectionFilters extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') {
      return;
    }

    this.dataset.initialized = 'true';
    this.desktopSlot = this.querySelector('[data-collection-filter-desktop-slot]');
    this.mobileSlot = this.querySelector('[data-collection-filter-mobile-slot]');
    this.filterContent = this.querySelector('[data-collection-filters-content]') || this.querySelector('[data-collection-facets]');
    this.mobileBreakpoint = window.matchMedia('(max-width: 767px)');

    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.addEventListener('click', this.handleClick);

    document.addEventListener('keydown', this.handleKeydown);

    if (typeof this.mobileBreakpoint.addEventListener === 'function') {
      this.mobileBreakpoint.addEventListener('change', this.handleBreakpointChange);
    } else {
      this.mobileBreakpoint.addListener(this.handleBreakpointChange);
    }

    this.handleBreakpointChange(this.mobileBreakpoint);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    document.removeEventListener('keydown', this.handleKeydown);

    if (!this.mobileBreakpoint) {
      return;
    }

    if (typeof this.mobileBreakpoint.removeEventListener === 'function') {
      this.mobileBreakpoint.removeEventListener('change', this.handleBreakpointChange);
    } else {
      this.mobileBreakpoint.removeListener(this.handleBreakpointChange);
    }

    this.closeSheet(true);
    this.restoreDesktopFilters();
  }

  handleClick(event) {
    if (event.target.closest('[data-collection-filter-open]')) {
      this.openSheet();
    } else if (event.target.closest('[data-collection-filter-close]')) {
      this.closeSheet();
    } else if (event.target.closest('[data-collection-filter-backdrop]')) {
      this.closeSheet();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeSheet();
    }
  }

  handleBreakpointChange(event) {
    if (!this.filterContent) {
      return;
    }

    if (event.matches && this.mobileSlot) {
      this.mobileSlot.appendChild(this.filterContent);
    } else {
      this.restoreDesktopFilters();
      this.closeSheet(true);
    }
  }

  restoreDesktopFilters() {
    if (this.desktopSlot && this.filterContent && this.filterContent.parentElement !== this.desktopSlot) {
      this.desktopSlot.appendChild(this.filterContent);
    }
  }

  get sheet() {
    return this.querySelector('[data-collection-filter-sheet]');
  }

  get backdrop() {
    return this.querySelector('[data-collection-filter-backdrop]');
  }

  openSheet() {
    const sheet = this.sheet;
    if (!sheet || !this.mobileBreakpoint.matches) {
      return;
    }

    sheet.hidden = false;
    this.backdrop?.removeAttribute('hidden');

    requestAnimationFrame(() => {
      sheet.classList.add('is-open');
    });

    document.body.classList.add('ab-filter-sheet-open');
  }

  closeSheet(force = false) {
    const sheet = this.sheet;
    if (!sheet) {
      return;
    }

    const shouldClose = force || sheet.classList.contains('is-open') || sheet.hidden === false;

    if (!shouldClose) {
      return;
    }

    sheet.classList.remove('is-open');
    this.backdrop?.setAttribute('hidden', 'hidden');
    document.body.classList.remove('ab-filter-sheet-open');

    const hideSheet = () => {
      sheet.hidden = true;
    };

    if (force) {
      hideSheet();
      return;
    }

    window.setTimeout(hideSheet, 260);
  }
}

if (!customElements.get('ab-collection-filters')) {
  customElements.define('ab-collection-filters', ABCollectionFilters);
}
